import { defineStore } from 'pinia'
import { ref } from 'vue'
import { i18n } from '@/i18n'

let nextId = 0

export const useAchievementToastsStore = defineStore('achievementToasts', () => {
  const items = ref([])

  const defaultIconsByKey = {
    first_pending: 'mdi-bookmark-plus',
    pending_10: 'mdi-bookmark-multiple',
    pending_25: 'mdi-bookmark-multiple'
  }
  function addAchievement(achievement) {
    const icon = achievement.icon ?? defaultIconsByKey[achievement.key] ?? 'mdi-trophy'
    items.value.push({
      id: `ach-${++nextId}-${Date.now()}`,
      name: achievement.name ?? i18n.global.t('achievementToasts.unlocked_name'),
      description: achievement.description ?? '',
      icon,
    })
  }

  function addAchievements(list) {
    if (!Array.isArray(list)) return
    list.forEach(addAchievement)
  }

  function remove(id) {
    items.value = items.value.filter((t) => t.id !== id)
  }

  return { items, addAchievement, addAchievements, remove }
})
